/**
 * @fileoverview gRPC-Web generated client stub for proto
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.1
// source: proto/feedback.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.proto = require('./feedback_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.FeedbackServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.FeedbackServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.CreateFeedbackRequest,
 *   !proto.proto.CreateFeedbackResponse>}
 */
const methodDescriptor_FeedbackService_CreateFeedback = new grpc.web.MethodDescriptor(
  '/proto.FeedbackService/CreateFeedback',
  grpc.web.MethodType.UNARY,
  proto.proto.CreateFeedbackRequest,
  proto.proto.CreateFeedbackResponse,
  /**
   * @param {!proto.proto.CreateFeedbackRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CreateFeedbackResponse.deserializeBinary
);


/**
 * @param {!proto.proto.CreateFeedbackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CreateFeedbackResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CreateFeedbackResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.FeedbackServiceClient.prototype.createFeedback =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.FeedbackService/CreateFeedback',
      request,
      metadata || {},
      methodDescriptor_FeedbackService_CreateFeedback,
      callback);
};


/**
 * @param {!proto.proto.CreateFeedbackRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CreateFeedbackResponse>}
 *     Promise that resolves to the response
 */
proto.proto.FeedbackServicePromiseClient.prototype.createFeedback =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.FeedbackService/CreateFeedback',
      request,
      metadata || {},
      methodDescriptor_FeedbackService_CreateFeedback);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.UpdateFeedbackRequest,
 *   !proto.proto.UpdateFeedbackResponse>}
 */
const methodDescriptor_FeedbackService_UpdateFeedback = new grpc.web.MethodDescriptor(
  '/proto.FeedbackService/UpdateFeedback',
  grpc.web.MethodType.UNARY,
  proto.proto.UpdateFeedbackRequest,
  proto.proto.UpdateFeedbackResponse,
  /**
   * @param {!proto.proto.UpdateFeedbackRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.UpdateFeedbackResponse.deserializeBinary
);


/**
 * @param {!proto.proto.UpdateFeedbackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.UpdateFeedbackResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.UpdateFeedbackResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.FeedbackServiceClient.prototype.updateFeedback =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.FeedbackService/UpdateFeedback',
      request,
      metadata || {},
      methodDescriptor_FeedbackService_UpdateFeedback,
      callback);
};


/**
 * @param {!proto.proto.UpdateFeedbackRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.UpdateFeedbackResponse>}
 *     Promise that resolves to the response
 */
proto.proto.FeedbackServicePromiseClient.prototype.updateFeedback =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.FeedbackService/UpdateFeedback',
      request,
      metadata || {},
      methodDescriptor_FeedbackService_UpdateFeedback);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeleteFeedbackRequest,
 *   !proto.proto.DeleteFeedbackResponse>}
 */
const methodDescriptor_FeedbackService_DeleteFeedback = new grpc.web.MethodDescriptor(
  '/proto.FeedbackService/DeleteFeedback',
  grpc.web.MethodType.UNARY,
  proto.proto.DeleteFeedbackRequest,
  proto.proto.DeleteFeedbackResponse,
  /**
   * @param {!proto.proto.DeleteFeedbackRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.DeleteFeedbackResponse.deserializeBinary
);


/**
 * @param {!proto.proto.DeleteFeedbackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.DeleteFeedbackResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.DeleteFeedbackResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.FeedbackServiceClient.prototype.deleteFeedback =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.FeedbackService/DeleteFeedback',
      request,
      metadata || {},
      methodDescriptor_FeedbackService_DeleteFeedback,
      callback);
};


/**
 * @param {!proto.proto.DeleteFeedbackRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.DeleteFeedbackResponse>}
 *     Promise that resolves to the response
 */
proto.proto.FeedbackServicePromiseClient.prototype.deleteFeedback =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.FeedbackService/DeleteFeedback',
      request,
      metadata || {},
      methodDescriptor_FeedbackService_DeleteFeedback);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ListFeedbackRequest,
 *   !proto.proto.ListFeedbackResponse>}
 */
const methodDescriptor_FeedbackService_ListFeedback = new grpc.web.MethodDescriptor(
  '/proto.FeedbackService/ListFeedback',
  grpc.web.MethodType.UNARY,
  proto.proto.ListFeedbackRequest,
  proto.proto.ListFeedbackResponse,
  /**
   * @param {!proto.proto.ListFeedbackRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ListFeedbackResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ListFeedbackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ListFeedbackResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ListFeedbackResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.FeedbackServiceClient.prototype.listFeedback =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.FeedbackService/ListFeedback',
      request,
      metadata || {},
      methodDescriptor_FeedbackService_ListFeedback,
      callback);
};


/**
 * @param {!proto.proto.ListFeedbackRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ListFeedbackResponse>}
 *     Promise that resolves to the response
 */
proto.proto.FeedbackServicePromiseClient.prototype.listFeedback =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.FeedbackService/ListFeedback',
      request,
      metadata || {},
      methodDescriptor_FeedbackService_ListFeedback);
};


module.exports = proto.proto;

